import {gql} from "@apollo/client";
import NETWORK_APOLLO_CLIENTS from "./apolloClient";


export const allSaleTransactions = async (saleAddress,version, chainId) => {
  const saleTransactionMetaQuery = `query {
    saleTransactions (where: {saleContractAddress: "${saleAddress}"}, orderBy: timestamp, orderDirection: desc) {
        __typename
        timestamp
        sender
      transactionHash
        saleContract {
        cooldownDuration
          token {
            id
            name
            decimals
            symbol
          }
          reserve {
            id
            name
            decimals
            symbol
          }
        }
        receipt {
          id
          receiptId
          fee
          units
          price
          feeRecipient
        }
        ... on SaleBuy {
          refunded
          totalIn
        }
        ... on SaleRefund {
          totalOut
        }
      }
    }`

    return NETWORK_APOLLO_CLIENTS[chainId][version].query({
        query: gql`${saleTransactionMetaQuery}`
    });
}

export const getSaleTransactionMetaService = async (saleContactAddress, sender, version, chainId) => {
    const saleTransactionMetaQuery = `query {
  saleTransactions (where: {saleContractAddress: "${saleContactAddress}", sender: "${sender}"}, orderBy: timestamp, orderDirection: desc) {
          __typename
          timestamp
    	  transactionHash
          saleContract {
          cooldownDuration
            token {
              id
              name
              decimals
              symbol
            }
            reserve {
              id
              name
              decimals
              symbol
            }
          }
          receipt {
            id
            receiptId
            fee
            units
            price
            feeRecipient
          }
          ... on SaleBuy {
            refunded
            totalIn
          }
          ... on SaleRefund {
            totalOut
          }
        }
      }`

    return NETWORK_APOLLO_CLIENTS[chainId][version].query({
        query: gql`${saleTransactionMetaQuery}`
    });
}
